// export.ts — CSV export of the flashcard collection (all local; nothing leaves the device).

import type { Card, Deck } from "./store";
import { SOURCE_LABELS } from "./store";
import { STATE_NEW, STATE_LEARNING, STATE_RELEARNING } from "./fsrs";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

function stateLabel(state: number): string {
  if (state === STATE_NEW) return "New";
  if (state === STATE_LEARNING || state === STATE_RELEARNING) return "Learning";
  return "Review";
}

/** Full CSV: Deck, Front, Back, Tag, Source, State, Due, Reps, Lapses, Last review. */
export function cardsCsv(decks: Deck[], cards: Card[]): string {
  const deckName = new Map(decks.map((d) => [d.id, d.name]));
  return csv(
    ["Deck", "Front", "Back", "Tag", "Source", "State", "Due", "Reps", "Lapses", "Last review"],
    cards.map((c) => [
      deckName.get(c.deck_id) ?? "",
      c.front,
      c.back,
      c.tag,
      SOURCE_LABELS[c.source] ?? c.source,
      stateLabel(c.state),
      c.due,
      c.reps,
      c.lapses,
      c.last_review ?? "",
    ]),
  );
}

export function buildExport(decks: Deck[], cards: Card[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: cardsCsv(decks, cards), filename: `flashcards-${stamp}.csv` };
}
